import {find, isEmpty} from 'lodash';

import {UserGroup, Group} from 'interfaces';

export const getGroupName = (id: string, groups: Group[]) => {
    if (!id) {
        return '';
    }
    const group = find(groups, {id});
    return group ? group.name : id;
};

export const getGroupId = (groupName: string, groups: Group[]) => {
    if (!groupName) {
        return '';
    }
    const group = find(groups, {name: groupName});
    return group ? group.id : groupName;
};

export const getSubgroupName = (groupId: string, subgroupId: string, groups: Group[]) => {
    if (!groupId || !subgroupId) {
        return '';
    }
    const group = find(groups, {id: groupId});
    if (!group || !Array.isArray(group.subgroups)) {
        return subgroupId;
    }
    const subgroup = find(group.subgroups, {id: subgroupId});
    return subgroup ? subgroup.name : subgroupId;
};

export const getSubgroupId = (groupName: string, subgroupName: string, groups: Group[]) => {
    if (!groupName || !subgroupName) {
        return '';
    }
    const group = find(groups, {name: groupName});
    if (!group || !Array.isArray(group.subgroups)) {
        return groupName;
    }
    const subgroup = find(group.subgroups, {name: subgroupName});
    return subgroup ? subgroup.id : subgroupName;
};

export const getUserGroupsNames = (userGroups: UserGroup[], groups: Group[]): string => {
    if (!Array.isArray(userGroups)) {
        return null;
    }
    const result = userGroups.map((group: UserGroup) => {
        const groupName = getGroupName(group.id, groups);
        const subgroupsNames = !Array.isArray(group.subgroups) ? null :
            group.subgroups.map((subgroup) => getSubgroupName(group.id, subgroup.id, groups));
        const subgroupsNamesStr = isEmpty(subgroupsNames) ? '' : ` (${subgroupsNames.sort().join(', ')})`;
        return groupName + subgroupsNamesStr;
    }).filter((name) => !!name).sort().join(', ');
    return result;
};

export const getAssignmentName = (group: Group[], groupId?: string, subgroupId?: string): string => {
    if (!groupId) {
        return '';
    }
    let assignment = getGroupName(groupId, group);
    if (subgroupId) {
        assignment += ` (${getSubgroupName(groupId, subgroupId, group)})`;
    }
    return assignment;
};